import { useState } from "react";
import { useSellarUser } from "../../hooks";
import { Dialog, DialogPage } from "../modal/Dialog";
import { ContainerEligibilityRulesPage } from "./pages/ContainerEligibilityRulesPage";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { PalletDeliverySettingsPage } from "./pages/PalletDeliverySettingsPage";
import { useSupplierUpdate } from "../../hooks/api/v2/supplier/useSupplierUpdate";
import { useRemoteFeatureFlags } from "../../hooks/useRemoteFeatureFlags";
import { CourierHaulierSwitchPromptPages } from "./CourierHaulierSwitchPrompt.shared";

export const CourierHaulierSwitchPrompt = () => {
  const [completedLocally, setCompletedLocally] = useState(false);

  const { business } = useSellarCurrentBusiness();
  const { user } = useSellarUser();

  const updateSupplier = useSupplierUpdate(business?.Supplier?.id ?? 0);

  const palletOverrideEnabled = useRemoteFeatureFlags().isActive(
    "courierHaulierSetup",
  );

  const unbundlingEnabled = useRemoteFeatureFlags().isActive(
    "unbundlingReleaseFinal",
  );

  const isAdmin = user?.type === "admin";

  // Derive dialog visibility from business + flags (no effect-driven setState).
  const active =
    !completedLocally &&
    palletOverrideEnabled &&
    business?.type === "supplier" &&
    !business.Supplier?.hasCompletedCourierHaulierSwitch &&
    !isAdmin &&
    !unbundlingEnabled;

  const onComplete = () => {
    if (!business?.Supplier?.id) return;

    updateSupplier.mutate(
      { hasCompletedCourierHaulierSwitch: true },
      {
        onSuccess: () => {
          setCompletedLocally(true);
        },
        onError: () => {
          setCompletedLocally(true);
        },
      },
    );
  };

  if (!palletOverrideEnabled) return <></>;

  return (
    <Dialog
      active={!!active}
      initPage={CourierHaulierSwitchPromptPages.CONTAINER_ELIGIBILITY_RULES}
    >
      <DialogPage
        page={CourierHaulierSwitchPromptPages.CONTAINER_ELIGIBILITY_RULES}
      >
        {active && <ContainerEligibilityRulesPage />}
      </DialogPage>

      <DialogPage
        page={CourierHaulierSwitchPromptPages.PALLET_DELIVERY_SETTINGS}
      >
        {active && <PalletDeliverySettingsPage onDismiss={onComplete} />}
      </DialogPage>
    </Dialog>
  );
};
